import { useQuery } from "@tanstack/react-query";
import { queryProposals } from "../../api/rental-financial-proposal";
import { QueryProposalsDto } from "../../dtos/rental-financial-proposal";
import { FinancialProposal } from "../../types";
import { AxiosResponse } from "axios";

export default function useQueryProposals(query: QueryProposalsDto) {
  return useQuery<AxiosResponse<FinancialProposal[]>, Error, FinancialProposal[]>(
    {
      queryKey: ["financial-proposals", [...query.trackUids]],
      queryFn: () => queryProposals(query),
      select: ({ data }) => data,
    }
  );
}
